import _ from 'lodash';
import { Link } from 'react-router';
import React from 'react';
/** import third-party libraries in the section above, Sort Lines Ascending */

import { BodyText } from 'widgets-v5/typography';
import { ButtonGroup, PrimaryButton } from 'widgets-v5/buttons';
import { Cell, ComposableDataTable, Row } from 'widgets-v5/data-table';
import { Pagination, PaginationRange } from 'widgets-v5/pagination';
import Card from 'widgets-v5/card';
import LoadGroup from 'widgets-v5/load-group';
import StandardInput from 'widgets-v5/standard-input';
import TopBarLayout from 'widgets/top-bar-layout';
/** import widgets components in the section above, Sort Lines Ascending */

import { isInternalUser } from 'states/profile/business-rules';
/** import single application imports in the section above, Sort Lines Ascending */

class Layout extends React.Component {
    getPoints(poi) {
        let points = 0;
        if (poi.source === 'cleanlist') {
            _.each(poi.cleanlist_entries, entry => {
                points += entry.points;
            });
        } else {
            points = poi.points;
        }
        return points.toLocaleString('en');
    }
    render() {
        return (
            <div className="pois-dashboard">
                <TopBarLayout
                    topBar={
                        <div>
                            <div className="pois-dashboard__page-title">
                                <ButtonGroup className="pois-dashboard__button-group">
                                    {
                                        // <div className="pois-dashboard__refresh-button">
                                        //     <GlobalRefresh
                                        //         heapEvent="poi-dashboard_refresh"
                                        //     />
                                        // </div>
                                    }
                                </ButtonGroup>
                            </div>
                            <div>
                                <StandardInput
                                    className="pois-dashboard__search-input"
                                    // Segment search supports name and id for all users; the id hint in the
                                    // placeholder is internal-only (not relevant for non-internal users).
                                    // Keep isInternalUser() here in case visibility rules change.
                                    placeholder={
                                        isInternalUser()
                                            ? 'Search by POI segment name or ID'
                                            : 'Search by POI segment name'
                                    }
                                    heapEvent="poi-dashboard_seach"
                                    value={this.props.filters.search || ''}
                                    onChange={this.props.search}
                                />
                                <PrimaryButton
                                    className="pois-dashboard__new-poi-button"
                                    onClick={this.props.goToNew}
                                    text="+ New Custom POI Segment"
                                    heapEvent="poi-dashboard_new-audience_navigate"
                                />
                            </div>
                        </div>
                    }
                    workspace={
                        <div className="pois-dashboard__wrapper">
                            <LoadGroup isLoading={this.props.isLoading}>
                                <Card padding={0}>
                                    <div>
                                        <ComposableDataTable>
                                            <Row header>
                                                <Cell header>ID</Cell>
                                                <Cell header>
                                                    Name (
                                                    {
                                                        <PaginationRange
                                                            itemsPerPage={this.props.itemsPerPage}
                                                            currentPage={this.props.currentPage}
                                                            maxResults={this.props.maxResults}
                                                        />
                                                    }
                                                    )
                                                </Cell>
                                                <React.Fragment>
                                                    <Cell header> Category </Cell>
                                                    <Cell header align="right">
                                                        Points
                                                    </Cell>
                                                    <Cell header align="right">
                                                        Radius (m)
                                                    </Cell>
                                                </React.Fragment>
                                            </Row>
                                            {this.props.pois.length === 0 ? (
                                                <Row key="noData">
                                                    <Cell colSpan={7} noData>
                                                        No POI segments found
                                                    </Cell>
                                                </Row>
                                            ) : (
                                                _.map(this.props.pois, poi => (
                                                    <Row key={poi._id}>
                                                        <Cell>
                                                            <Link
                                                                className="pois-dashboard__reports-table-link"
                                                                to={`/presets/pois/${poi._id}`}
                                                            >
                                                                #{poi._id}
                                                            </Link>
                                                        </Cell>
                                                        <Cell>
                                                            <Link
                                                                className="pois-dashboard__reports-table-link"
                                                                to={`/presets/pois/${poi._id}`}
                                                            >
                                                                <BodyText type="link">
                                                                    {poi.name}
                                                                </BodyText>
                                                            </Link>
                                                        </Cell>
                                                        <React.Fragment>
                                                            <Cell>
                                                                {' '}
                                                                {_.get(
                                                                    poi,
                                                                    'category.name',
                                                                    ''
                                                                )}{' '}
                                                            </Cell>
                                                            <Cell align="right">
                                                                {this.getPoints(poi)}
                                                            </Cell>
                                                            <Cell align="right">
                                                                {' '}
                                                                {poi.radius.toLocaleString(
                                                                    'en'
                                                                )}{' '}
                                                            </Cell>
                                                        </React.Fragment>
                                                    </Row>
                                                ))
                                            )}
                                        </ComposableDataTable>
                                        <Pagination
                                            heapEvent="poi-dashboard_pagination_navigate"
                                            url="/presets/pois"
                                            query={this.props.filters}
                                            padding={2}
                                            itemsPerPage={this.props.itemsPerPage}
                                            currentPage={this.props.currentPage}
                                            maxResults={this.props.maxResults}
                                        />
                                    </div>
                                </Card>
                            </LoadGroup>
                        </div>
                    }
                />
            </div>
        );
    }
}

export default Layout;
